import { createContext } from "react";
import { DEFAULT_LANG } from "./supportedLangs";

export default createContext(DEFAULT_LANG);
